export default function () {
  const keydownClass = 'c-keydown';
  const body = window.document.querySelector('body');

  body.addEventListener('mousedown', () => {
    body.classList.remove(keydownClass);
  });

  body.addEventListener('keydown', (event) => {
    const keyCode = event.keyCode || event.which;
    if (keyCode === 9) {
      body.classList.add(keydownClass);
    }
  });
}
